module.exports = __webpack_public_path__ + "img/cerrar.dbf8657b.png";